import { render } from "./UpdateUnitDetails.vue?vue&type=template&id=6bb16378&scoped=true"
import script from "./UpdateUnitDetails.vue?vue&type=script&lang=js"
export * from "./UpdateUnitDetails.vue?vue&type=script&lang=js"

import "./UpdateUnitDetails.vue?vue&type=style&index=0&id=6bb16378&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb16378"]])

export default __exports__